import {AccountMin, ExternalWhoAmIResponse} from "../../Types";
import {invalidateQueries, q} from "../../state";
import jsonApi from "./jsonApi";

export async function login(account: AccountMin, token: string) {
  return await jsonApi.post<"ok">(
    `/region/${account.region}/external_api/accounts/${account.account_id}/login`,
    undefined,
    {
      headers: {Authorization: `Bearer ${token}`},
    },
  );
}

export async function logout(account: AccountMin) {
  await jsonApi.post<"ok">(`/region/${account.region}/external_api/accounts/${account.account_id}/logout`);
  await invalidateQueries([q.external.filter()]);
}

export async function whoAmI(account: AccountMin): Promise<ExternalWhoAmIResponse> {
  return await jsonApi.get(`/region/${account.region}/external_api/accounts/${account.account_id}/whoami`);
}
